import React, { Fragment, useEffect, useState } from "react";
import { socket } from "../../common/cores/socket";
import SportsCenter from "../../components/sports/SportsCenter";
import SportsRight from "../../components/sports/SportsRight";
import connect from "react-redux/lib/connect/connect";
import { ClearBetStore } from "../../common/actions/betAction";
import {
  ClearSportsList,
  GetSportsList
} from "../../common/actions/sportsAction";
import { SetPageInfo } from "../../common/actions/pageAction";
import TitleBox from "../../components/common/TitleBox";
import LeftBar from "../../components/sports/sportscomponent/LeftBar";

const SportsPrematch = props => {
  const [showLeft, setShowLeft] = useState(false);
  const { sports } = props

  // props.ClearBetStore();
  // props.ClearSportsList();
  // useEffect(() => {
  //     // props.ClearBetStore();
  //     // props.ClearSportsList();
  //     socket.emit('room', roomObj);
  //     props.SetPageInfo(roomObj);
  // }, []);

  const roomObj = {
    pageType: "toto",
    RoomType: "sport",
    sportType: "sport",
    gameType: "prematch",
    sportId: sports.sportId,
    esportType: "all"
  };
  const roomData = {
      MessageType: "RoomType",
      data: roomObj
    };
    if(window.ws.readyState === 1)
      window.ws.send(JSON.stringify(roomData));
  props.SetPageInfo(roomObj);

  const onSetShowLeft = () => {
    setShowLeft(!showLeft);
  };

  return (
    <Fragment>
      <TitleBox title="스포츠" />
      <div className="contents_wrap">
        <div className="contents_box">
          <LeftBar onSetShowLeft={onSetShowLeft} type="prematch" title="스포츠 (해외형)" history={props.history} roomObj={roomObj} />
          <SportsCenter
            roomObj={roomObj}
            type="prematch"
            onSetShowLeft={onSetShowLeft}
          />
          <SportsRight type="prematch" />
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = state => ({
  sports: state.sports,
});

export default connect(
  mapStateToProps,
  {
    ClearSportsList,
    ClearBetStore,
    SetPageInfo,
    GetSportsList
  }
)(SportsPrematch);



// WEBPACK FOOTER //
// ./src/containers/Sports/SportsPrematch.js